import { Box, Button, Grid, IconButton, Paper, TextField, Typography } from "@mui/material";
import React, { ChangeEvent, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import captchaService from "../../services/captcha-service";
import SongContent from "../../types/song-type";
import DeleteIcon from "@mui/icons-material/Delete";

const AddSong: React.FC = () => {
  const [songNumber, setSongNumber] = useState<string>("");
  const [songContent, setSongContent] = useState<string>("");
  const [songs, setSongs] = useState<SongContent[]>([]);

  const handleSongNumberChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setSongNumber(event.target.value);
  };

  const handleSongContentChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setSongContent(event.target.value);
  };

  useEffect(() => {
    getAllSongs();
  }, []);

  const parseSongContent = (content: string): string[] => {
    const lines = content.split("\n").map((line) =>
      line
        .replace(/^(\d+\.\s*)/, "") // Remove the verse number and period
        .replace(/[/.;!,]/g, "") // Remove slashes, periods, and semicolons
        .trim()
    );

    const verses = lines.filter((line) => line !== "");

    const shortenedVerses = verses.map((verse) =>
      verse.split(" ").slice(0, 11).join(" ")
    );
    console.log(shortenedVerses);
    return shortenedVerses;
  };

  const handleSongSubmit = async () => {
    try {
      if (
        isNaN(Number(songNumber)) ||
        songNumber === "" ||
        songContent === ""
      ) {
        (isNaN(Number(songNumber)) || songNumber === "") &&
          toast.warning("Song number must be a valid number.", {
            position: "bottom-right",
          });
        songContent === "" &&
          toast.warning("You didn't add any content!", {
            position: "bottom-right",
          });
        return;
      }

      const parsedContent = parseSongContent(songContent);

      const newSong: SongContent = {
        songNumber: songNumber,
        verses: parsedContent,
        language: window.localStorage.getItem("language") || "en",
      };

      await captchaService.createCaptcha(newSong);
      toast.success("Song successfully added!");
      setSongNumber("");
      setSongContent("");
    } catch (error) {
      console.error("Failed to add song!", error);
    }
  };

  const getAllSongs = async () => {
    const songResponse = await captchaService.getAllSongs();
    if (songResponse) {
      setSongs(songResponse.data);
    }
  };

  const handleDeleteSong = (song: SongContent) => {
    if (!song.id) {
      console.error("Song ID is undefined");
      return;
    }
    captchaService.deleteSong(song.id).then(
      () => {
        const updatedSongs = songs.filter(
          (currentSong) => currentSong.id !== song.id
        );
        toast.success("Song successfully deleted!");
        setSongs(updatedSongs);
      },
      (error) => {
        console.error(
          "Unable to delete song!",
          error
        );
        toast.error("Unable to delete song!");
      }
    );
  }

  return (
    <Grid container padding={2}>
      <Grid item xs={12}>
        <Box sx={{ my: 2 }}>
          <Typography variant="h6">
            <FormattedMessage id="add-new-song" />
          </Typography>

          <TextField
            fullWidth
            margin="normal"
            variant="outlined"
            label={<FormattedMessage id="song-title" />}
            value={songNumber}
            onChange={handleSongNumberChange}
          />

          <TextField
            fullWidth
            margin="normal"
            variant="outlined"
            label={<FormattedMessage id="content" />}
            value={songContent}
            onChange={handleSongContentChange}
            multiline
            rows={4}
          />

          <Button
            variant="contained"
            color="primary"
            onClick={handleSongSubmit}
          >
            <FormattedMessage id="submit" />
          </Button>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Typography>Available songs</Typography>
        {songs.map((song: SongContent) => (
          <Paper>
            <Typography>{song.songNumber}</Typography>
            <Typography>
              {song.verses.map((verse: string, index: number) => (
                <Typography key={index} sx={{ marginBottom: 1 }}>
                  {index + 1}. {verse}
                </Typography>
              ))}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <IconButton
                          onClick={() => handleDeleteSong(song)}
                          color="error"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Box>
          </Paper>
        ))}
      </Grid>
    </Grid>
  );
};

export default AddSong;
